import cn from 'classnames';
import Container from './container';
interface Props {
  className?: string;
  children?: any;
  el?: HTMLElement;
  clean?: boolean;
}

const RichTextContainer: React.FC<Props> = ({ children, className, clean }) => {
  const rootClassName = cn(className, {
    'mx-auto px-4 whitespace-pre-line max-w-[1280px]': !clean,
  });

  return (
    <Container className={`${rootClassName} whitespace-pre-line`}>
      {children}
    </Container>
  );
};

export default RichTextContainer;
